module.exports = __webpack_public_path__ + "static/media/hell.4410274a.gif";